const { CarouselElement } = window.BAO.Carousel
const { useArrows, useCurrentSlideIndicator } = window.BAO.Carousel.plugins

export class ProductInfoDrawerCarousel extends CarouselElement {
  static get requiredElements () {
    return ['slider', 'slide', 'previous', 'next', 'status']
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.drawer) {
      const onDrawersOpen = event => {
        if (event.detail.key !== this.drawer.key) return

        const images = this.drawer.querySelectorAll('img')
        images.forEach(image => {
          image.loading = 'auto'
        })

        document.removeEventListener('site-drawers:open', onDrawersOpen)
      }

      document.addEventListener('site-drawers:open', onDrawersOpen)
    }
  }

  beforeInitialiseCarousel () {
    this.attachCarouselClasses()
  }

  attachCarouselClasses () {
    this.els.slider.element.classList.add('keen-slider')
    this.els.slide.elements.forEach(slide => {
      slide.classList.add('keen-slider__slide')
    })
  }

  /** @returns {KeenSliderPlugin[]} */
  get plugins () {
    const { element: statusElement } = this.els.status

    return [
      useArrows({
        next: this.els.next.element,
        previous: this.els.previous.element,
      }),
      useCurrentSlideIndicator(statusElement, statusElement.dataset.template),
    ]
  }

  get drawer () {
    return this.closest('site-drawer')
  }
}

if (!customElements.get('product-info-drawer-carousel')) {
  customElements.define(
    'product-info-drawer-carousel',
    ProductInfoDrawerCarousel,
  )
}
